import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { IconLogout } from './icons';

const DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
const MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

function formatDate(d) {
  return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}
function formatTime(d) {
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export default function Topbar({ title, subtitle }) {
  const { user, logout } = useAuth();
  const [now, setNow] = useState(new Date());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const name = user?.full_name || user?.username || 'Administrateur';
  const initials = name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <header className="topbar">
      <div className="topbar__title">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <div className="topbar__right">
        <div className="clock">
          <span>{formatDate(now)}</span>
          {formatTime(now)} GMT
        </div>

        <div className="usermenu">
          <button className="usermenu__chip" onClick={() => setOpen((v) => !v)}>
            <span className="usermenu__avatar">{initials}</span>
            <span className="usermenu__name">{name}</span>
            <span className="usermenu__caret">▾</span>
          </button>

          {open && (
            <>
              <div className="usermenu__backdrop" onClick={() => setOpen(false)} />
              <div className="usermenu__dropdown">
                <div className="usermenu__head">
                  <div className="usermenu__avatar usermenu__avatar--lg">{initials}</div>
                  <div>
                    <div className="usermenu__fullname">{name}</div>
                    <div className="usermenu__email">{user?.email || 'Administrateur'}</div>
                  </div>
                </div>
                <button className="usermenu__logout" onClick={logout}>
                  <IconLogout width={17} height={17} />
                  <span>Se déconnecter</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
